import { render, staticRenderFns } from "./DistSelection.vue?vue&type=template&id=54ed5f1e&scoped=true&"
import script from "./DistSelection.vue?vue&type=script&lang=js&"
export * from "./DistSelection.vue?vue&type=script&lang=js&"
import style0 from "./DistSelection.vue?vue&type=style&index=0&id=54ed5f1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ed5f1e",
  null
  
)

export default component.exports